/* eslint-disable import/prefer-default-export, react/prop-types */

import React from 'react';
import TopLayout from './TopLayout';
import client from './apollo';
import { ApolloProvider } from '@apollo/client/react/context';

if (typeof window === 'undefined') {
  global.window = {}
}

export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>
    <TopLayout>{element}</TopLayout>
  </ApolloProvider>
);
